export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-v1-960-747db695c1b7f4514d21a77fefcfd0a1.webp";